import React, { useEffect, useState } from "react";
import { Unstable_NumberInput as NumberInput } from "@mui/base/Unstable_NumberInput";

import { IconChevronDown, IconChevronUp } from "../../design-system/icons";

export const DemandNumberField = ({ value, ariaLabel, onValueChange }) => {
  const numericValue = Number(value || 0);
  const valueClassName = numericValue > 0 ? "is-positive" : "is-zero";
  const [inputValue, setInputValue] = useState(
    numericValue === 0 ? "" : String(numericValue)
  );

  useEffect(() => {
    setInputValue(numericValue === 0 ? "" : String(numericValue));
  }, [numericValue]);

  return (
    <NumberInput
      className={`demand-v2__number-field ${valueClassName}`}
      value={numericValue}
      placeholder="0"
      min={0}
      max={999}
      step={1}
      onInputChange={(event) => setInputValue(event.currentTarget.value)}
      onChange={(_event, nextValue) => {
        const nextNumericValue = nextValue ?? 0;
        setInputValue(nextNumericValue === 0 ? "" : String(nextNumericValue));
        onValueChange(nextNumericValue);
      }}
      slotProps={{
        input: {
          "aria-label": ariaLabel,
          inputMode: "numeric",
          role: "spinbutton",
          value: inputValue,
        },
        incrementButton: {
          "aria-label": `${ariaLabel}: erhöhen`,
          children: <IconChevronUp aria-hidden="true" />,
        },
        decrementButton: {
          "aria-label": `${ariaLabel}: verringern`,
          children: <IconChevronDown aria-hidden="true" />,
        },
      }}
    />
  );
};

export default DemandNumberField;
